<template>
  <div v-if="!hydrated" class="text-center">
    <div class="spinner-grow" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="spinner-grow" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-else>
    <div class="card" v-for="(taglist, family) in tags" :key="family">
      <div class="card-header">
        {{ family }}
        <span v-if="family !== 'Other'" class="bi bi-trash text-danger" @click="removeFamily(family)"></span>
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item" v-for="tag in taglist">
          <Tag :tag="tag" :current-family="family" :families="families"
               @remove-tag="removeTag"
               @change-family="changeFamily">
          </Tag>
        </li>
      </ul>
    </div>
  </div>

  <div class="input-group mt-3 mb-3">
    <input type="text" class="form-control" placeholder="New tag" aria-label="New tag"
           aria-describedby="new-tag-addon" v-model="newTag">
    <button class="btn btn-outline-success" type="button" id="new-tag-addon" @click="addTag">Add Tag</button>
  </div>

  <div class="input-group mt-3 mb-3">
    <input type="text" class="form-control" placeholder="New group" aria-label="New group"
           aria-describedby="new-group-addon" v-model="newGroup">
    <button class="btn btn-outline-success" type="button" id="new-group-addon" @click="addGroup">Add Group</button>
  </div>

  <div class="input-group mt-3 mb-3">
    <button class="btn btn-success" disabled v-if="saveInProgress">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Saving...
    </button>
    <button v-else class="btn btn-success" @click="saveTags">Save</button>
  </div>
</template>

<script>
import axios from "axios";
import Tag from "./tags_admin/Tag.vue";

function removeFromArray(arr, value) {
  return arr.filter(function (ele) {
    return ele !== value;
  });
}

export default {
  name: "TagsAdmin",
  data() {
    return {
      tags: {},
      families: [],
      hydrated: false,
      saveInProgress: false,
      newGroup: '',
      newTag: '',
    }
  },
  components: {Tag},
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      axios.get('/api/admin/tags')
        .then(response => {
          console.log('Tags data loaded:', response.data);
          this.tags = response.data.tags;
          this.families = response.data.families;
          this.hydrated = true;
        })
        .catch(error => {
          console.error('Failed to load tags:', error);
          this.hydrated = true;
        });
    },
    addGroup() {
      if (!this.newGroup) {
        return;
      }

      this.tags[this.newGroup] = [];
      this.families.push(this.newGroup);
      this.newGroup = '';
    },
    addTag() {
      if (!this.newTag) {
        return;
      }

      if (!this.tags['Other']) {
        this.tags['Other'] = [];
      }
      this.tags['Other'].push(this.newTag);
      this.newTag = '';
    },
    changeFamily(tag, oldFamily, newFamily) {
      this.tags[oldFamily] = removeFromArray(this.tags[oldFamily], tag);
      this.tags[newFamily].push(tag);
    },
    saveTags() {
            this.saveInProgress = true;
            const bodyFormData = new FormData();
            bodyFormData.append('tags', JSON.stringify(this.tags));
            axios.post('/api/admin/tags/update', bodyFormData).then(response => {
                this.tags = response.data.tags;
                this.families = response.data.families;
                this.saveInProgress = false;
            });
        },
    removeFamily(family) {
      this.families = removeFromArray(this.families, family);
      const familyTags = this.tags[family];
      delete this.tags[family];
      
      if (!this.tags['Other']) {
        this.tags['Other'] = [];
      }
      this.tags['Other'] = this.tags['Other'].concat(familyTags);
    },
    removeTag(tag, family) {
      this.tags[family] = removeFromArray(this.tags[family], tag);
    }
  },
};
</script>
